import {
  SET_PACKAGE_NAME,
  SET_PACKAGE_SKU
} from './actions-constants';

export const setCheckoutPackageName = (packageName) => ({
  type: SET_PACKAGE_NAME,
  payload: packageName
});

export const setCheckoutPackageSKU = (packageSku) => ({
  type: SET_PACKAGE_SKU,
  payload: packageSku
});
